<template>
  <v-toolbar flat class="header-container" height="75px">
    <v-toolbar-side-icon
      id="header-menu-btn-lhs"
      @click.stop="$emit('handleToggleLhsToolbar')"
    ></v-toolbar-side-icon>
    <v-badge color="orange darken-3" overlap class="uxl-icon-badge" v-model="hasUnsavedChangesAndNotLoading">
      <v-icon slot="badge" medium>mdi-adjust</v-icon>
      <span>&nbsp;</span>
    </v-badge>
    <v-toolbar-title id="header-canvas-title-container">
      <v-tooltip bottom>
          <span
            slot="activator"
            class="tooltip-caption"
            @click="$emit('handleQueryNameClick')"
          ></span>
        <span>{{ $t('headerNavBar.fileProperties')}}</span>
      </v-tooltip>
      <v-tooltip bottom>
          <span
            slot="activator"
            @click="$emit('handleQueryNameClick')"
            id="header-canvas-title"
          >{{ query && query.name ? newQueryNameTrimmed : $t('headerNavBar.untitledFile') }}</span>
        <span>{{ query && query.name ? query.name : $t('headerNavBar.renameFile')}}</span>
      </v-tooltip>
    </v-toolbar-title>
    <v-toolbar-items class="header-btn-container">
      <v-tooltip bottom id="header-btn-share" class="header-btn-share-container no-wrap">
        <span slot="activator" @click="$emit('handleShareClick')" class="button">
          <v-icon slot="activator" class="header-btn">share</v-icon>
        </span>
        <span>{{ $t('headerNavBar.shareTooltip') }}</span>
      </v-tooltip>
    </v-toolbar-items>
    <img id="header-main-logo" src="../../../static/logo-2dsearch.svg" alt="2Dsearch logo">
    <v-toolbar-side-icon
      id="header-menu-btn-rhs"
      @click.stop="$emit('handleToggleRhsProfileMenu')"
    >
      <v-icon id="header-menu-btn-rhs-icon">account_circle</v-icon>
    </v-toolbar-side-icon>
  </v-toolbar>
</template>

<script>
import '../../style/_variables.scss'

export default {
  name: 'main-header',
  props: ['hasUnsavedChangesAndNotLoading', 'query'],
  computed: {
    newQueryNameTrimmed: {
      get () { return this.$store.getters.getTrimmedQueryName(this.query.name) }
    }
  }
}
</script>

<style lang="scss" scoped>
// Navigation Bar
#header {
  &-canvas-title {
    &-container {
      cursor: pointer;
    }

    padding: $length-small-m;
    margin-right: 1rem;
    border: $length-small-xs solid $grey-400;
    border-radius: 0.15em;
    font-size: 20px;

    &:hover {
      border-color: $grey-800;
    }
  }

  &-main-logo {
    position: absolute;
    left: calc(50vw - 95px);
  }

  &-menu-btn-lhs {
    font-size: 32px;
    margin-left: 20px;
  }

  &-menu-btn-rhs {
    position: absolute;
    right: 10px;
    &-icon {
      font-size: 30px;
    }
  }
}
.header-btn-container {
  height: fit-content;
}
.header-btn-share-container {
  margin: $length-small-l 0;
  padding: $length-small-m $length-small-l;
  height: unset;
  border-radius: $length-small-m;
  transition: background-color 200ms;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &:hover {
    background-color: $grey-400;
    height: unset;
  }
}
.button:hover {
  cursor: pointer;
}
.header-btn {
  margin-top: $length-small-m;
  color: inherit;
}
#header-menu-btn-lhs-badge {
  background-color: $orange;
}
// Toolbar overriding
.header-container {
  position: relative;
}
.theme--light .header-container.toolbar {
  background-color: $bg-primary;
  z-index: 100;
  height: 75px;
  border-bottom: 3px solid $black-900;
}
.theme--light .header-container .btn:not(.btn--icon):not(.btn--flat) {
  color: $blue-grey-600;
  background-color: rgba(255,255,255,0.5);
}
.theme--light .header-container.toolbar .subheading {
  overflow: visible;
}
.header-container .toolbar__items .btn {
  margin-right: 5px;
  min-width: $length-med-xl;
}
.header-container .toolbar__items .btn--small .btn__content {
  padding: 3px;
  box-shadow: 0 3px $length-small-xs -$length-small-s rgba(0,0,0,.2), 0 $length-small-s $length-small-s 0 rgba(0,0,0,.14), 0 $length-small-xs 5px 0 rgba(0,0,0,.12);
  color: #546e7a;
  background-color: hsla(0,0%,100%,.5);
}
.header-container .toolbar__items .btn:hover .btn__content:before {
  background-color: transparent;
}
.header-container .toolbar__items .btn:hover .btn__content {
  background-color: $grey-200;
}
// Helper
.toolbar .tooltip-caption {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/MainHeader.vue